import { FC } from "react";

interface Props {
	profile: SocialProfile | null;
}

const PersonProfileTab: FC<Props> = ({ profile }) => {
	if (!profile) {
		return (
			<div className="rounded-xl border border-border bg-subtle shadow-sm p-6">
				<p className="text-sm text-zinc-600">No linked profile found.</p>
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-4">
			{/* Job Title */}
			<div className="rounded-xl border border-border bg-subtle shadow-sm p-6">
				<label className="font-heading text-lg font-medium text-foreground mb-4 block">
					Job Title
				</label>
				<p className="text-sm text-foreground">
					{profile.jobTitle || <span className="text-zinc-600">Not set</span>}
				</p>
			</div>

			{/* Org Team */}
			<div className="rounded-xl border border-border bg-subtle shadow-sm p-6">
				<label className="font-heading text-lg font-medium text-foreground mb-4 block">
					Org Team
				</label>
				<div className="flex flex-col gap-3">
					<div>
						<p className="text-sm text-zinc-600 mb-0.5">Level 1</p>
						<p className="text-sm text-foreground">
							{profile.orgTeamLevelOne || (
								<span className="text-zinc-600">Not set</span>
							)}
						</p>
					</div>
					<div>
						<p className="text-sm text-zinc-600 mb-0.5">Level 2</p>
						<p className="text-sm text-foreground">
							{profile.orgTeamLevelTwo || (
								<span className="text-zinc-600">Not set</span>
							)}
						</p>
					</div>
					<div>
						<p className="text-sm text-zinc-600 mb-0.5">Level 3</p>
						<p className="text-sm text-foreground">
							{profile.orgTeamLevelThree || (
								<span className="text-zinc-600">Not set</span>
							)}
						</p>
					</div>
				</div>
			</div>

			{/* Feeds */}
			<div className="rounded-xl border border-border bg-subtle shadow-sm p-6">
				<label className="font-heading text-lg font-medium text-foreground mb-4 block">
					Feeds
				</label>
				<div className="flex flex-col gap-4">
					<div>
						<p className="text-sm text-zinc-600 mb-1">Preferred feed</p>
						<p className="text-sm text-foreground">
							{profile.preferredFeed || (
								<span className="text-zinc-600">Not set</span>
							)}
						</p>
					</div>
					<div>
						<p className="text-sm text-zinc-600 mb-1">Subscribed feeds</p>
						{profile.subscribedFeeds.length > 0 ? (
							<div className="flex flex-wrap gap-2 mt-1">
								{profile.subscribedFeeds.map((feed) => (
									<span
										key={feed}
										className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-zinc-100 text-zinc-700 border border-zinc-200"
									>
										{feed}
									</span>
								))}
							</div>
						) : (
							<p className="text-sm text-zinc-600">None</p>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default PersonProfileTab;
